<template>
  <div style="margin-top: 20px">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#5bad2b"
      :is-full-page="fullPage"
    ></loading>
    <div class="container maincontent">
      <!-- <div class="col-md-12"> -->
        <div class="row postdata">
          <div class="col" style="margin-top: 20px">
            <div class="nav">
              <div class="box-header">
                <h3 class="box-title pageTitle">Interest</h3>
              </div>
              <hr class="myline" />
              <div class="card">
                <div class="myIntRes">
                  <div class="card-header p-2 tabHeader">
                    <ul class="nav nav-pills tabBtn">
                      <li class="nav-item active tabBtnRes1">
                        <a
                          id="tabBtnRes"
                          class="nav-link active"
                          href="#sent"
                          data-toggle="tab"
                          @click="sent()"
                          ><strong class="intexp1">
                            <i class="fa fa-arrow-up" aria-hidden="true"></i>
                            Sent</strong
                          ></a
                        >
                      </li>
                      <li class="nav-item tabBtnRes2">
                        <a
                          id="tabBtnRes"
                          class="nav-link"
                          href="#received"
                          data-toggle="tab"
                          @click="receive()"
                          ><strong class="intexp1"
                            ><i class="fa fa-arrow-down" aria-hidden="true"></i>
                            Received</strong
                          ></a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body">
                  <div class="tab-content">
                    <div class="active tab-pane" id="sent">
                      <div class="box-header with-border filterdata">
                        <input
                          v-model="postsearch"
                          @keyup="sent()"
                          type="text"
                          class="form-control pull-left search-text"
                          placeholder="Search"
                          style="width: 50%; height: 30%"
                        />
                        <div style="width: 50%" class="pull-right filterby">
                          <div class="form-group">
                            <div
                              class="form-select pull-right"
                              style="width: 50%; height: 30%"
                            >
                              <select
                                @change="sent()"
                                v-model="postsort"
                                class="form-control input-sm"
                              >
                                <option value="7">Last 7 days</option>
                                <option value="30">Last 30 days</option>
                              </select>
                              <span class="select-icon"
                                ><i class="fa fa-chevron-down"></i
                              ></span>
                            </div>
                          </div>
                          <span class="pull-right ml-1">Sort by</span>
                        </div>
                      </div>
                      <div class="text-center">
                        <div class="box-body">
                          <ul
                            style="list-style: none"
                            v-for="(interest, index) in myInterestData"
                            :key="index"
                          >
                            <li class="myPostArea">
                              <div class="postArea">
                                <div
                                  type="button"
                                  data-toggle="modal"
                                  data-target="#mypost"
                                  @click="sentDetails(interest)"
                                  class="myorgData"
                                >
                                  <div class="Orgimage">
                                    <img
                                      class="round"
                                      v-if="
                                        interest.profile_picture != '' &&
                                          interest.profile_picture != null
                                      "
                                      :src="`${interest.profile_picture}`"
                                      alt=""
                                    />
                                    <img
                                      class="round"
                                      v-if="
                                        interest.profile_picture == '' ||
                                          interest.profile_picture == null
                                      "
                                      src="../../../assets/img/default.png"
                                      alt=""
                                    />
                                  </div>
                                  <div class="intDetails">
                                    <div class="uniqueId">
                                      <div>
                                        <strong class="myorgName"
                                          >{{ interest.organization }}
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="position">
                                  <div class="val">
                                    <label class="labelcss" for="">Position: </label>
                                    <div style="font-size: 14px">
                                      <p class="mytitle">{{ interest.job_tittle }}</p>
                                    </div>
                                  </div>
                                  <!-- <div class="val">
                                          <label for="">Primary Skills:</label>
                                          <span>Angular 2,ASPNET</span>
                                        </div> -->
                                </div>
                                <div
                                    v-if="
                                      interest.post_expired === 'true'
                                    "
                                    style="color:#ff2627"
                                    >Expired</div
                                  >
                                <div class="intstatus" v-else>
                                  <!-- <div class="myBookmark"><i class="fa fa-bookmark-o bookmarkicon" aria-hidden="true"></i>     <span> 2.30 pm</span>
</div> -->
                                  <p
                                    v-if="
                                      interest.statusval !== 'uninterest' &&
                                        interest.status == 'uninterest' &&
                                        interest.statusval !== 'cancelled' &&
                                        interest.statusval !== 'Declined'
                                    "
                                    class="pull-right status"
                                    style="color:#5bad2b"
                                  >
                                    Interested
                                  </p>
                                  <button
                                    type="button"
                                    v-if="
                                      interest.status == 'uninterest' &&
                                        (interest.statusval == '' ||
                                          interest.statusval == null)
                                    "
                                    class="btn btn-danger myBtn"
                                    :disabled="interest.post_expired === 'true' "
                                    @click="
                                      uninterest(interest._id, interest.user_id)
                                    "
                                  >
                                    UnInterest
                                  </button>
                                  <span
                                    v-if="
                                      interest.status === 'Accepted' &&
                                        (interest.statusval == '' ||
                                          interest.statusval == null)
                                    "
                                    style="color:#5bad2b"
                                    >Accepted</span
                                  >
                                  <span
                                    v-if="
                                      interest.status == 'Interest' &&
                                        (interest.statusval == '' ||
                                          interest.statusval == null)
                                    "
                                    class="pull-right"
                                    style="color:#5bad2b"
                                  >
                                    Interested</span
                                  >
                                  <span
                                    v-if="interest.statusval == 'Declined'"
                                    class="pull-right"
                                    style="color:#ff2627"
                                    >Declined</span
                                  >
                                  <span
                                    v-if="interest.statusval == 'cancelled'"
                                    class="pull-right"
                                    style="color:#ff2627"
                                  >
                                    Cancelled</span
                                  >
                                </div>
                              </div>
                              <hr style="margin-top:2px; margin-bottom:6px" />
                              <div class="timeofInterest">
                                <div class="vali">
                                  <label class="labelcss" for="">Validity</label>
                                  <p class="valdate">
                                    {{ interest.post_validity | formatDate }}
                                  </p>
                                </div>
                                <div class="vali">
                                  <label class="labelcss">Interested Date & Time -</label>
                                  <p class="valdate">
                                    {{
                                      interest.interviewer_interest_date
                                        | formatDatetimea
                                    }}
                                  </p>
                                </div>
                                <!-- <div class="vali" v-if="interest.statusval == 'cancelled'">
                                    <label>Cancelled Date & Time -</label>
                                    <p>
                                      {{ interest.interviewer_interest_date | formatDatetimea }}
                                    </p>
                                  </div> -->
                              </div>
                            </li>
                          </ul>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="received">
                      <div class="box-header with-border filterdata">
                        <input
                          v-model="postsearch"
                          @keyup="receive()"
                          type="text"
                          class="form-control pull-left search-text"
                          placeholder="Search"
                          style="width: 50%; height: 30%"
                        />
                        <div style="width: 50%" class="pull-right filterby">
                          <div class="form-group">
                            <div
                              class="form-select pull-right"
                              style="width: 50%; height: 30%"
                            >
                              <select
                                @change="receive()"
                                v-model="postsort"
                                class="form-control input-sm"
                              >
                                <option value="7">Last 7 days</option>
                                <option value="30">Last 30 days</option>
                              </select>
                              <span class="select-icon"
                                ><i class="fa fa-chevron-down"></i
                              ></span>
                            </div>
                          </div>
                          <span class="pull-right ml-1">Sort by</span>
                        </div>
                      </div>
                      <div class="text-center">
                        <div class="box-body">
                          <ul
                            style="list-style: none"
                            v-for="(Receive, index) in myInterestReceive"
                            :key="index"
                          >
                            <li class="myPostArea">
                              <div class="postArea">
                                <div
                                  type="button"
                                  data-toggle="modal"
                                  data-target="#mypost2"
                                  @click="receiveDetails(Receive, index)"
                                  class="myorgData"
                                >
                                  <div class="Orgimage">
                                    <img
                                      class="round"
                                      v-if="
                                        Receive.profile_picture != '' &&
                                          Receive.profile_picture != null
                                      "
                                      :src="`${Receive.profile_picture}`"
                                      alt=""
                                    />
                                    <img
                                      class="round"
                                      v-if="
                                        Receive.profile_picture == '' ||
                                          Receive.profile_picture == null
                                      "
                                      src="../../../assets/img/default.png"
                                      alt=""
                                    />
                                    <!-- <img
                                            class="round"
                                            src="https://images.unsplash.com/photo-1657524432873-c37d2ac7b8cb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                                            alt=""
                                          /> -->
                                  </div>
                                  <div class="intDetails">
                                    <div class="uniqueId">
                                      <div style="font-size: 14px">
                                        <strong
                                          >{{ Receive.organization }}
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="position">
                                  <div class="val">
                                    <label class="labelcss" for="">Position: </label>
                                    <div style="font-size: 14px">
                                      <p class="mytitle">{{ Receive.job_tittle }}</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="intstatus1">
                                  <label class="labelcss" for=""></label>
                                  <div class="InterestStatus">
                                    <span
                                      v-if="
                                        Receive.status == 'Accepted' &&
                                          (Receive.statusval == '' ||
                                            Receive.statusval == null)
                                      "
                                      class="pull-right"
                                      style="color: #5bad2b"
                                      >Accepted</span
                                    >
                                    <span
                                      v-if="Receive.statusval == 'Declined'"
                                      class="pull-right"
                                      style="color: #ff2627"
                                    >
                                      Declined</span
                                    >
                                    <span
                                      v-if="Receive.statusval == 'cancelled'"
                                      class="pull-right"
                                      style="color: #ff2627"
                                      >Cancelled</span
                                    >
                                  </div>
                                  <div class="InterestState">
                                    <button
                                    type="button"
                                      v-if="
                                        Receive.status === 'Accept' &&
                                          (Receive.statusval == '' ||
                                            Receive.statusval == null)
                                      "
                                      @click="
                                        interestReceiveAccept(
                                          Receive._id,
                                          Receive.user_id
                                        )
                                      "
                                      class="btn btn-success myBtn"
                                      aria-hidden="true"
                                    >
                                      Accept
                                    </button>
                                    <!-- <span v-if="Receive.status =='Accepted' && (Receive.statusval =='' || Receive.statusval ==null)" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span> -->
                                    <!-- <span
                                      v-if="Receive.statusval == 'Declined'"
                                      class="pull-right"
                                      style="color: #ff2627"
                                    >
                                      Declined</span
                                    > -->
                                    <!-- <span
                                      v-if="Receive.statusval == 'cancelled'"
                                      class="pull-right"
                                      style="color: #ff2627"
                                      >Cancelled</span
                                    > -->
                                    <button
                                      type="button"
                                      v-if="
                                        Receive.statusval != 'Declined' &&
                                          Receive.status == 'Accept' &&
                                          Receive.statusval != 'cancelled'
                                      "
                                      class="btn btn-danger myBtn"
                                      data-toggle="modal"
                                      data-target="#Cancel"
                                      @click="
                                        receiveUserid = Receive.user_id;
                                        declinepopup(Receive._id);
                                      "
                                    >
                                      Decline
                                    </button>
                                    <button
                                      type="button"
                                      v-if="
                                        Receive.statusval != 'Declined' &&
                                          Receive.status == 'Accepted' &&
                                          Receive.statusval != 'cancelled'
                                      "
                                      class="btn btn-danger myBtn"
                                      data-toggle="modal"
                                      data-target="#Cancel"
                                      @click="
                                        cancelButton = true;
                                        receiveUserid = Receive.user_id;
                                        declinepopup(Receive._id);
                                      "
                                    >
                                      Cancel
                                    </button>
                                  </div>

                                  <!-- <div class="timeofInterest">
                                      <p>Interested Date & Time</p>
                                      <p>{{Receive.org_interest_date}}</p>
                                    </div> -->
                                  <!-- <div class="myBookmark"><i class="fa fa-bookmark-o bookmarkicon" aria-hidden="true"></i>     <span> 2.30 pm</span>
</div> -->
                                  <!-- <div><p style="color:purple">Schedule Awaited</p></div> -->
                                  <!-- <button
                                          type="button"
                                          class="btn btn-success"
                                        > -->
                                  <!-- <i
                                            class="fa fa-check"
                                            aria-hidden="true"
                                          ></i> -->
                                  <!-- {{Receive.status}}
                                        </button> -->
                                </div>
                              </div>
                              <hr style="margin-top:2px; margin-bottom:6px" />
                              <div class="timeofInterest">
                                <div class="vali">
                                  <label class="labelcss" for="">Validity:</label>
                                  <p class="mytitle">
                                    {{ Receive.post_validity | formatDate }}
                                  </p>
                                </div>
                                <div class="vali" v-if="Receive.status == 'Accept'">
                                  <label class="labelcss">Interested Date & Time -</label>
                                  <p class="mytitle">{{ Receive.org_interest_date }}</p>
                                </div>
                                <!-- <div class="vali" v-if="Receive.status == 'Accept'">
                                  <label class="labelcss">Cancelled Date & Time -</label>
                                  <p class="mytitle">{{ Receive.org_interest_date }}</p>
                                </div> -->
                              </div>
                            </li>
                          </ul>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <!-- Modal for #sentinterest -->
    <div
      class="modal fade"
      id="mypost"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title closebtnmodel" id="exampleModalLabel">
              <strong style="font-size: 18px"
                >Hi {{ firstName.first_name }}</strong
              >
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
          </div>
          <div class="modal-body modalbody">
            <div class="myPostArea">
            <div class="postArea">
              <div class="myorgData1">
                <div class="Orgimage">
                  <img
                    class="profile-user-img img-fluid img-circle myprofile"
                    v-if="
                      intData.profile_picture != '' &&
                        intData.profile_picture != null
                    "
                    :src="`${intData.profile_picture}`"
                    alt=""
                  />
                  <img
                    class="myprofile"
                    v-if="
                      intData.profile_picture == '' ||
                        intData.profile_picture == null
                    "
                    src="../../../assets/img/default.png"
                    alt=""
                  />
                  <div class="intDetails">
  <div class="uniqueId">
  <div class="org"><strong class="myorgName">{{intData.organization}}</strong>
  </div>
</div>
  </div>
                    </div>
                </div>
                <div class="intDetails">
                  <div class="uniqueId">

                    <div class="val">
                        <label class="labelcss" for="">Position: </label>
                        <div style="font-size: 14px">
                          <p class="mytitle">{{ intData.job_tittle }}</p>
                        </div>
                      </div>
                  </div>
                </div>
              <div class="popupinterestbtn">
                <p
                  v-if="
                    intData.statusval !== 'uninterest' &&
                      intData.status == 'uninterest' &&
                      intData.statusval !== 'cancelled' &&
                      intData.statusval !== 'Declined'
                  "
                  class="pull-right status"
                  style="color:#5bad2b"
                >
                  Interested
                </p>
                <button
                  v-if="
                    intData.status == 'uninterest' &&
                      (intData.statusval == '' || intData.statusval == null)
                  "
                  type="button"
                  class="btn btn-danger myBtn"
                  data-toggle="modal"
                  data-target="#uninterest"
                  @click="tempSkill(intData._id, intData.user_id, index)"
                >
                  UnInterest
                </button>
                <span
                  v-if="
                    intData.status == 'Accepted' &&
                      (intData.statusval == '' || intData.statusval == null)
                  "
                  style="color:#5bad2b"
                  >Accepted</span
                >
                <span
                  v-if="
                    intData.status == 'Interest' &&
                      (intData.statusval == '' || intData.statusval == null)
                  "
                  class="pull-right"
                  style="color:#5bad2b"
                >
                  Interested</span
                >
                <span
                  v-if="intData.statusval == 'Declined'"
                  class="pull-right"
                  style="color:#ff2627"
                  >Declined</span
                >
                <span
                  v-if="
                    intData.status == 'cancelled' ||
                      intData.statusval == 'cancelled'
                  "
                  class="pull-right"
                  style="color:#ff2627"
                >
                  Cancelled</span
                >
              </div>
            </div>
  <hr style="margin-top:2px; margin-bottom:6px" />
                            <div class="myBookmark">
                  <label class="labelcss" for="">Validity: </label>
                  <p class="valdate">{{ intData.post_validity | formatDate }}</p>
                </div>

            </div>
            <div class="postDetails">
              <div class="postHead">
                <h4 class="myHeading">Post Details</h4>
                <p class="received">
                  <i class="fa fa-arrow-up" aria-hidden="true"></i>Sent
                </p>
              </div>
              <hr />
              <div class="postDatas">
                <div class="Intdetails">
                  <label class="labelcss" for="">Primary Skills :</label>
                  <p class="mytitle">{{ postDetail.primaryskillnames }}</p>
                </div>
                <div class="Intdetails">
                  <label class="labelcss" for="">Secondary Skills :</label>
                  <p class="mytitle">{{ postDetail.secondaryskillnames }}</p>
                </div>
                <div class="Intdetails">
                  <label class="labelcss" for="">Experience :</label>
                  <p class="mytitle">
                    {{ intData.year_of_experience }} Year
                    {{ intData.month_of_experience }} month
                  </p>
                </div>
                <div class="Intdetails">
                  <label class="labelcss" for="">Interview type :</label>
                  <p class="mytitle">{{ intData.job_interview_type }}</p>
                </div>
              </div>
            </div>
            <div class="JobDescription">
              <h4 class="myHeading">Job Description</h4>
              <hr />
              <p class="mytitle">
                <span>{{ intData.org_description }}</span>
              </p>
            </div>
            <hr />
            <div class="comments">
              <h4 class="myHeading">Comments</h4>
              <hr />
              <div>
                <p class="mytitle">{{ intData.job_comments }}</p>
              </div>
            </div>
          </div>
          <!-- mysent footer  -->
          <!-- <div class="modal-footer">
            <div class="InterestStatus">
              {{ intData.statuslabel }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Modal for #mypost2 -->
    <div
      class="modal fade"
      id="mypost2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title closebtnmodel" id="exampleModalLabel">
              <strong style="font-size: 18px">Hi User</strong>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
          </div>
          <div class="modal-body modalbody">
            <div class="myPostArea">
            <div class="postArea">
              <div class="myorgData1">
                <div class="Orgimage">
                  <img
                    class="profile-user-img img-fluid img-circle myprofile"
                    v-if="
                      receiveData.profile_picture != '' &&
                        receiveData.profile_picture != null
                    "
                    :src="`${receiveData.profile_picture}`"
                    alt=""
                  />
                  <img
                    class="round"
                    v-if="
                      receiveData.profile_picture == '' ||
                        receiveData.profile_picture == null
                    "
                    src="../../../assets/img/default.png"
                    alt=""
                  />
                  <!-- <img
                    class="round"
                    src="https://images.unsplash.com/photo-1657524432873-c37d2ac7b8cb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                    alt=""
                  /> -->
                </div>
                <div class="intDetails">
                  <div class="uniqueId">
                    <div style="font-size: 14px">
                      <p class="myorgName">{{ receiveData.organization }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="valpop">
                        <label class="labelcss" for="">Position: </label>
                        <div style="font-size: 14px">
                          <p class="mytitle">{{ receiveData.job_tittle }}</p>
                        </div>
                      </div>
              <div class="popupinterestbtn">
                <div class="InterestState">
                  <button
                  type="button"
                    v-if="
                      receiveData.status === 'Accept' &&
                        (receiveData.statusval == '' ||
                          receiveData.statusval == null)
                    "
                    @click="
                      interestReceiveAccept(
                        receiveData._id,
                        receiveData.user_id
                      )
                    "
                    class="btn btn-success myBtn"
                    :disabled="receiveData.post_expired === 'true'"
                    aria-hidden="true"
                  >
                    Accept
                  </button>
                  <span
                    v-if="
                      receiveData.status == 'Accepted' &&
                        (receiveData.statusval == '' ||
                          receiveData.statusval == null)
                    "
                    class="pull-right"
                    style="color: #5bad2b"
                    >Accepted</span
                  >
                  <span
                    v-if="receiveData.statusval == 'Declined'"
                    class="pull-right"
                    style="color: #ff2627"
                  >
                    Declined</span
                  >
                  <span
                    v-if="receiveData.statusval == 'cancelled'"
                    class="pull-right"
                    style="color: #ff2627"
                    >Cancelled</span
                  >
                  <div>
                    <button
                      type="button"
                      v-if="
                        receiveData.statusval != 'Declined' &&
                          receiveData.status == 'Accept' &&
                          receiveData.statusval != 'cancelled'
                      "
                      class="btn btn-danger myBtn"
                      :disabled="receiveData.post_expired === 'true'"
                      data-toggle="modal"
                      data-target="#Cancel"
                      @click="
                        receiveUserid = receiveData.user_id;
                        declinepopup(receiveData._id);
                      "
                    >
                      Decline
                    </button>
                    <button
                      type="button"
                      v-if="
                        receiveData.statusval != 'Declined' &&
                          receiveData.status == 'Accepted' &&
                          receiveData.statusval != 'cancelled'
                      "
                      class="btn btn-danger myBtn"
                      data-toggle="modal"
                      data-target="#Cancel"
                      @click="declinepopup(receiveData._id)"
                    >
                      Cancel
                    </button>
                    <!-- <span
                      v-if="receiveData.statusval === 'Declined'"
                      class="pull-right"
                      style="color: #ff2627"
                    >
                      Declined</span
                    > -->
                  </div>
                </div>
              </div>
            </div>
            <hr style="margin-top:2px; margin-bottom:6px" />
  <div class="vali">
  <label  class="labelcss" for="">Validity:</label>
  <p class="valdate">{{receiveData.post_validity | formatDate }} </p>
  </div>
  <!-- <div class="myBookmark">
                  <label class="labelcss" for="">Validity: </label>
                  <p class="valdate">{{ receiveData.post_validity | formatDate }}</p>
                </div> -->
            </div>
            <div class="postDetails">
              <div class="postHead">
                <h4>Post Details</h4>
                <p class="sent">
                  <i class="fa fa-arrow-down" aria-hidden="true"></i>Received
                </p>
              </div>
              <hr />
              <div class="postDatas">
                <div class="Intdetails">
                  <label class="labelcss" for="">Primary Skills :</label>
                  <p class="mytitle">{{ postDetail.primaryskillnames }}</p>
                </div>
                <div class="Intdetails">
                  <label class="labelcss" for="">Secondary Skills :</label>
                  <p class="mytitle">{{ postDetail.secondaryskillnames }}</p>
                </div>
                <div class="Intdetails">
                  <label class="labelcss" for="">Experience :</label>
                  <p class="mytitle">
                    {{ receiveData.year_of_experience }} Year
                    {{ receiveData.month_of_experience }} month
                  </p>
                </div>
                <div class="Intdetails">
                  <label class="labelcss" for="">Interview type :</label>
                  <p class="mytitle">{{ receiveData.job_interview_type }}</p>
                </div>
              </div>
            </div>
            <div class="JobDescription">
              <h4>Job Description</h4>
              <hr />
              <p class="mytitle" >
                <span>{{ receiveData.org_description }}</span>
              </p>
            </div>
            <hr />
            <div class="comments">
              <h4>Comments</h4>
              <hr />
              <div>
                <p class="mytitle">{{ receiveData.job_comments }}</p>
              </div>
            </div>
          </div>
          <!-- footer for received popup -->
          <!-- <div class="modal-footer"> -->
          <!-- <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button> -->
          <!-- <div class="InterestStatus">
              <span
                v-if="
                  receiveData.status == 'Accepted'"
                class="pull-right"
                style="color: #5bad2b"
                >Accepted</span
              >
              <span
                v-if="receiveData.statusval == 'Declined'"
                class="pull-right"
                style="color: #ff2627"
              >
                Declined</span
              >
              <span
                v-if="receiveData.statusval == 'cancelled'"
                class="pull-right"
                style="color: #ff2627"
                >Cancelled</span
              >
            </div> -->
          <!-- <label class="labelcss" type="button" class="btn btn-success">
              {{Receive.statuslabel}}
            </label> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!--  modal for Cancel-->
    <div
      class="modal fade"
      id="Cancel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog deleteskillmodal" role="document">
        <div class="modal-content" style="width: 50%">
          <div class="modal-header">
            <h4 class="modal-title closebtnmodel" id="exampleModalLabel">
              Cancellation
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h4>
          </div>
          <div class="modal-body ">
            <h4 class="skilltitle">Cancel the Interview Schedule</h4>
            <div>
              <div class="form-group">
                <div class="form-select">
                  <select
                    id="orgtype"
                    v-model="reasonName"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.reasonName.$error }"
                    @change="selectedValue()"
                  >
                    <!-- <option>Select reason*</option>
                          <option v-for="reason in reasonList"
            :key="reason" :value="reason.value" class="text" disabled
                            >{{reason.value}}</option
                          > -->
                    <option value="">Select reason*</option>
                    <option
                      v-for="get in reasonList"
                      :key="get.value"
                      :value="get.value"
                    >
                      {{ get.value }}
                    </option>
                  </select>
                  <span class="select-icon"
                    ><i class="fa fa-chevron-down"></i
                  ></span>
                </div>
                <div
                  v-if="submitted && $v.reasonName.$error"
                  class="invalid-feedback"
                  style="color: red; text-align: left"
                >
                  <span
                    v-if="!$v.reasonName.required"
                    style="color: red; font-size: 12px"
                    >*select a Reason</span
                  >
                </div>
              </div>
              <textarea
                placeholder="Enter your comments*"
                class="invalid-feedback mytxtarea"
                name=""
                id=""
                cols="50"
                rows="5"
                v-model="comments"
                :class="{ 'is-invalid': submitted && $v.comments.$error }"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              v-if="cancelButton !== true"
              type="button"
              class="btn"
              @click="uninterest(receivePostId, receiveUserid)"
            >
              Submit
            </button>
            <button
              v-if="cancelButton === true"
              type="button"
              class="btn"
              @click="receiveCancel(receivePostId, receiveUserid)"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for uninterest---->
    <div
      class="modal fade"
      id="uninterest"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog deleteskillmodal" role="document">
        <div class="modal-content" style="width: 50%">
          <div class="modal-header">
            <h4 class="modal-title skilltitle" id="exampleModalLabel">
              Confirmation
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h4>
          </div>
          <div class="modal-body  modalbody1 ">
            <div>
            <p class="mytitle">Are you sure want Uninterest this post?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn"
              @click="uninterest(tempId, tempUserId, tempIndex)"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
import moment from 'moment'
import $ from 'jquery'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      reasonName: '',
      cancelReason: '',
      submitted: false,
      btnHide: true,
      isLoading: false,
      postsearch: '',
      postsort: 7,
      user_id: localStorage.getItem('user_id'),
      fullPage: true,
      status: '',
      intData: [],
      receiveData: [],
      myInterestData: [],
      myInterestReceive: [],
      postDetail: [],
      postId: '',
      myCurrentDate: '',
      myPastDate: '',
      startdate: '',
      enddate: '',
      pskill: [],
      sskill: [],
      org_id: '',
      reason_id: '',
      reason_name: '',
      comments: '',
      tobeCancel: '',
      myReceiveCancel: [],
      reasonList: [],
      btnstatus: '',
      sheduledetailsOpen: false,
      firstName: [],
      receiveUserid: '',
      cancelButton: false
    }
  },
  components: {
    Loading
  },
  created () {
    localStorage.getItem('user_id')
    this.firstName = JSON.parse(localStorage.getItem('user__details'))
    console.log(this.user_id)
    this.sent()
    this.receive()
    this.getReason()
    // this.sentDetails()

    // this.postDetails()
  },
  methods: {
    sent () {
      // if (this.postsort === 0) {
      //   this.postsort = 0
      //   this.myCurrentDate = ''
      //   this.myPastDate = ''
      // } else {
      this.myCurrentDate = moment().format('YYYY-MM-DD')
      console.log(this.myCurrentDate)
      this.myPastDate = moment()
        .subtract(this.postsort, 'days')
        .format('YYYY-MM-DD')
      console.log(this.myPastDate)
      // }
      const data = {
        // user_id: localStorage.getItem('_id'),
        sort: this.postsort,
        startdate: this.myPastDate,
        enddate: this.myCurrentDate,
        search: this.postsearch,
        status: this.status
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      // this.$router.push({ name: 'PostDetails' })
      axios
        .post(
          BaseURL +
            '/dashboard/get_post_interested/ios/' +
            this.user_id +
            '/sent',
          { formData: data },
          config
        )
        .then(response => {
          this.myInterestData = response.data.postDetails
          this.postId = response.data.postDetails.map(item => item._id)
          console.log(this.postId)
          // this.sentDetails()
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    receive () {
      // if (this.postsort === 0) {
      //   this.postsort = 0
      //   this.myCurrentDate = ''
      //   this.myPastDate = ''
      // } else {
      this.myCurrentDate = moment().format('YYYY-MM-DD')
      console.log(this.myCurrentDate)
      this.myPastDate = moment()
        .subtract(this.postsort, 'days')
        .format('YYYY-MM-DD')
      console.log(this.myPastDate)
      // }
      // this.myCurrentDate = moment().format('YYYY-MM-DD')
      // console.log(this.myCurrentDate)
      // this.myPastDate = moment().subtract(this.postsort, 'days').format('YYYY-MM-DD')
      // console.log(this.myPastDate)
      const data = {
        // user_id: localStorage.getItem('_id'),
        sort: this.postsort,
        startdate: this.myPastDate,
        enddate: this.myCurrentDate,
        search: this.postsearch,
        status: this.status
        // bookmark: this.form.interview_cost
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      // this.$router.push({ name: 'PostDetails' })
      axios
        .post(
          BaseURL +
            '/dashboard/get_post_interested/ios/' +
            this.user_id +
            '/receive',
          { formData: data },
          config
        )
        .then(response => {
          this.myInterestReceive = response.data.postDetails
          // this.post_id = response.data.postDetails

          console.log(this.myInterestReceive)
        })
        .catch(error => {
          console.log(error)
        })
    },
    sentDetails (data) {
      // console.log(data)
      this.intData = data
      this.postDetails(this.intData._id)
      console.log(this.intData)
    },
    receiveDetails (data) {
      this.receiveData = data
      this.postDetails(this.receiveData._id)
      console.log(this.receiveData)
    },
    tempSkill (_id, userID, index) {
      this.tempUserId = userID
      this.tempId = _id
      this.tempIndex = index
    },
    uninterest (_id, orgId) {
      $('#uninterest').modal('hide')
      $('#Cancel').modal('hide')
      $('#mypost2').modal('hide')
      this.isLoading = true
      // $('button[name=uninterestbutton]')
      //   .click(
      //     function () {
      //       $(this).hide()
      //     }
      //   )
      const data = {
        user_id: localStorage.getItem('user_id'),
        post_id: _id,
        org_id: orgId,
        reason_id: this.reason_id,
        reason_name: this.reason_name,
        comments: this.comments
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .post(
          BaseURL + '/dashboard/update_user_uninterest/ios',
          { formData: data },
          config
        )
        .then(response => {
          this.myUnInterest = response.data.interestInfo
          this.successMsg = response.data.message
          this.btnstatus = this.myUnInterest[0].status
          console.log(this.btnstatus)
          this.intData.status = 'cancelled'
          this.intData.statuslabel = 'cancelled'
          this.successMsg = response.data.message
          this.receive()
          this.isLoading = false
          this.$awn.success('Post Uninterested Successfully')
          this.sent()
          this.sentDetails(this.intData)
          // this.tempSkill(this.tempId, this.tempUserId, this.tempIndex)
          console.log(this.myUnInterest)
        })
        .catch(error => {
          console.log(error)
        })
    },
    declinepopup (_id) {
      console.log(this.receiveData.status)
      this.receivePostId = _id
      console.log('cancelButton ---- ', this.cancelButton)
    },
    postDetails (_id) {
      this.post_id = _id
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(
          BaseURL +
            '/dashboard/get_post_details/ios/' +
            this.post_id +
            '/' +
            this.user_id,
          config
        )
        .then(response => {
          this.postDetail = response.data.interviewerList[0]
          console.log(this.postDetail)
        })
        .catch(error => {
          console.log(error)
        })
    },
    receiveCancel (postId, orgId) {
      $('#Cancel').modal('hide')
      $('#mypost2').modal('hide')
      const data = {
        user_id: localStorage.getItem('user_id'),
        post_id: postId,
        org_id: Number(orgId),
        reason_id: this.reason_id,
        reason_name: this.reason_name,
        comments: this.comments,
        tobe_cancel_by: 'mobile'
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .post(
          BaseURL + '/dashboard/cancel_tobeschedule',
          { formData: data },
          config
        )
        .then(response => {
          this.myReceiveCancel = response.data.scheduleList
          this.receiveData.status = 'Accepted'
          this.receiveData.statuslabel = 'Declined'
          this.receive()
          this.receiveDetails(this.receiveData)

          this.$awn.success('Reason submitted Successfully')
          // this.btnHide = false
          // this.sent()
          console.log(this.myUnInterest)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getReason () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(BaseURL + '/dashboard/get_cancel_reason/ios', config)
        .then(response => {
          this.reasonList = response.data.reasonlist
          console.log(this.reasonList)
        })
        .catch(error => {
          console.log(error)
        })
    },
    selectedValue () {
      for (var i = 0; i < this.reasonList.length; i++) {
        if (this.reasonList[i].value === this.reasonName) {
          this.reason_id = this.reasonList[i]._id
          this.reason_name = this.reasonList[i].value
        }
      }
    },
    interestReceiveAccept (_id, orgId) {
      $('#mypost').modal('hide')
      this.isLoading = true
      const data = {
        user_id: localStorage.getItem('user_id'),
        post_id: _id,
        org_id: orgId
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .post(
          BaseURL + '/dashboard/add_interviewer_interest/ios',
          { formData: data },
          config
        )
        .then(response => {
          this.myInterest = response.data.interestInfo
          this.receiveData.status = 'Accepted'
          this.receiveData.statuslabel = 'Declined'
          this.isLoading = false
          this.$awn.success('The post is Accepted')
          this.receive()
          this.receiveDetails(this.receiveData)
          // this.getDatas()
          // this.receiveCancel()
          console.log(this.myInterest)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.myPostArea {
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.postArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 6px;
}
.postBg {
  background: #f5f5f5;
}
.maincontent {
  background-color: white;
  padding: 10px;
}
.myIntRes {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.tabHeader {
  width: 30%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  // background-color: #f5f5f5;
}
.tabHeader .icon {
  display: none;
}
.tabBtn {
  // background-color: #f5f5f5;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  column-gap: 10px;
}
.tabBtn > li > a {
  position: relative;
  display: block;
  // padding: 14px 27px;
  font-size: 14px;
  text-align: center;
}
.tabBtn > li.active > a,
.tabBtn > li.active > a:focus,
.tabBtn > li.active > a:hover {
  color: #fff;
  background-color: #5bad2b;
  border-top-color: unset;
}
.tabBtn > li > a:hover {
  // color: black;
  background-color: whitesmoke;
}
.profile-user-img {
  margin: 0px auto;
  width: 130px;
  padding: 1px;
  border: 4px solid #d2d6de;
}
.img-circle {
  border-radius: 50%;
}
.myprofile {
  width: 120px;
  height: 120px;
}
.round {
  width: 100px;
  height: 100px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 4px;
}
.uniqueId {
  display: flex;
  text-align: start;
}
.position {
  display: flex;
  text-align: start;
  flex-direction: column;
}
.myorgData {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.myorgData:hover {
  cursor: pointer;
  // background-color: white;
}
.Orgimage{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
}
.myorgData1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.filterdata {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 8px  0px;
}
.ml-1{
  margin-top: 6px;
 }
// .filterby{
//   align-items: center;
// }
.navTab {
  display: flex;
  justify-content: center;
}
.valpop{
  display: flex;
  justify-content: center;
  align-items: baseline;
  flex-direction: row;
  font-size: 12px;
}
.myBookmark {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 5px;
  align-content: center;
  align-items: baseline;
  padding: 0% 5px;
}
.bookmarkicon {
  font-size: 15px;
}
.cancelicon {
  font-size: 18px;
  -webkit-text-stroke: 1px #d73925;
}
.interestbtn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  row-gap: 2px;
  padding-right: 10px;
}
.popupinterestbtn {
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  align-items: stretch;
}
.closebtnmodel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
}
.val {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: baseline;
  column-gap: 3px;
}
.postDatas {
  display: grid;
  grid-template-columns: 50% 50%;
}
.Intdetails {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
}
.postHead {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.sent {
  color: orange;
}
.received {
  color: blue;
}
.tabBtnRes1,
.tabBtnRes2 {
  width: 50%;
  background-color: lightgray;
}
.myline {
  margin-top: 0;
  margin-bottom: 10px;
}
.pageTitle {
  font-size: 24px;
  font-weight: 400;
}
.InterestStatus {
  color: #5bad2b;
  padding: 4px;
  text-align: center;
}
.InterestState {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  column-gap: 10px;
}
.deleteskillmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.skilltitle {
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.intstatus {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: stretch;
  column-gap: 4px;
}
.intstatus1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  row-gap: 4px;
padding-bottom: 10px;
}
.myorgName {
  font-size: 16px;
  font-weight: 600;
}
.vali {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-content: center;
  align-items: baseline;
  column-gap: 5px;
  padding-right: 5px;
}
.timeofInterest {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0% 1%;
  column-gap: 10px;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
   .labelcss,.mytitle,.intstatus,.valdate{
    font-size: 12px;
   }
   .skilltitle{
    font-size: 14px;
   }
   .myorgName{
font-size: 12px;
padding-top: 10px;
   }
   .myBtn{
    font-size: 10px;
   }
 .round{
    width: 80px;
    height: 80px;
   }
.myprofile {
    width: 80px;
    height: 80px;
}
.interestbtn{
  padding: 0%;
}
.tabBtn > li > a{
  font-size: 10px;
}
.tabHeader{
  width: 60%;
}
.val{
  padding-top: 10px;
}
.myorgData,.myorgData1{
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  row-gap: 5px;
  column-gap: 5px;
}
.myBookmark{
  display: flex;
  justify-content: end;
  flex-direction: row;
  padding-right: 5px;
}
.popupinterestbtn{
  text-align: center;
  font-size: 10px;
  padding: 0%;
}
.intstatus1{
  flex-direction: row;
 padding-top: 10px;
}
.InterestStatus{
  font-size: 12px;
}
.Orgimage{
  row-gap: 8px;
  flex-direction: column;
}
.valpop{
   display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: baseline;
  column-gap: 3px;
  padding-top: 10px;
}
.myHeading,.pageTitle{
  font-size: 16px;
}
.status{
  font-size: 12px;
  margin-bottom:3px;
}
.InterestState{
  flex-direction: column;
  font-size: 12px;
  row-gap: 4px;
}
.modalbody{
  padding: 6px;
}
.deleteskillmodal{
  width: 100%;
}
.mytxtarea{
  width: 100%;
}
}
</style>
